const logos = {
  main: require('./logo-educat.png'),
  mainWhite: require('./logo-educat--white.png'),
};

export default logos;
